/**
 * 空函数
 */
export default () => {}



// WEBPACK FOOTER //
// ./src/packages/utils/src/noop.js